// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"76c55fb9","258":"87dcb31d","352":"d26ed3d7","385":"f30f748d","452":"46219afd","594":"ea811910","771":"970f2e1b"}[chunkId] + ".chunk.css";
};